import BaseModel from "lib/model";
import Globalize from "globalize";

const Retailer = BaseModel.extend({
    props: {
        buyer: "objectId",
        buyer_name: "string",
        ref: "objectId",
        retailer_name: "string",
    },
});

export default BaseModel.extend({
    idAttribute: "_id",
    url: function () {
        return `/brand/${this.parent._id}/cart`;
    },
    props: {
        _id: "objectId",
        line_items_count: { type: "number", default: 0, required: true },
        total: { type: "currency", default: 0, required: true },
        currencySymbol: { type: "string", default: "" },
        order_flow_type: { type: "string", values: ["prebook", "immediate"] },
        currency_code: { type: "string", required: true },
        __uninitiated_order: { type: "boolean" },
        selected_warehouse: { type: "string" },
    },
    children: {
        retailer: Retailer,
    },
    derived: {
        _mode: {
            deps: ["order_flow_type"],
            fn: function () {
                switch (this.order_flow_type) {
                    case "immediate":
                        return Globalize.formatMessage("Immediate");
                    case "prebook":
                        return Globalize.formatMessage("Pre-Book");
                    default:
                        return "";
                }
            },
        },
    },
});
